export default __webpack_public_path__ + "static/media/12.ac5b35ad.jpg";